import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@/lib/utils';

const VerticalTabs = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Root ref={ref} className={cn('flex', className)} {...props} />
));
VerticalTabs.displayName = TabsPrimitive.Root.displayName ?? 'VerticalTabs';

const VerticalTabsList = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(
  (
    { className, ...props }: React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => (
    <TabsPrimitive.List
      ref={ref}
      className={cn(
        'flex flex-col min-w-[238px] items-start pr-8 text-muted-foreground bg-transparent py-4 px-0 justify-start gap-2',
        className
      )}
      {...props}
    />
  )
);
VerticalTabsList.displayName = 'VerticalTabsList';

const VerticalTabsTrigger = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(
  (
    { className, ...props }: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => (
    <>
      <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
          'flex w-full items-center justify-start text-left whitespace-nowrap text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50  data-[state=active]:text-foreground data-[state=active]:font-semibold  data-[state=active]:bg-sidebar-accent p-2 rounded-lg',
          className
        )}
        {...props}
      />
    </>
  )
);
VerticalTabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export { VerticalTabs, VerticalTabsList, VerticalTabsTrigger };
